//# sourceMappingURL=columns.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/columns.interface.js
// module id = 1163
// module chunks = 4